<template>
  <div class="monitor_fire">
    <div class="monitor_fire-row">
      <div class="monitor_fire-body">
        <div class="hj">
          <div class="monitor_fire-left">
            <img
              class="top-img"
              src="/images/newscreen/icon/top-real.png"
            >
          </div>
          <div class="monitor_fire-right">
            <div
              class="monitor_fire-right-title"
              style="color: #E1574D;;font-size: 16px;"
            >
              真实火警
            </div>
            <div
              class="monitor_fire-right-warn"
              style="color: #E1574D; font-size: 24px;"
            >
              {{ tjxxInfo.zshj === null ? '0' : tjxxInfo.zshj }}
            </div>
          </div>
        </div>
      </div>
      <div class="monitor_fire-body">
        <div class="hj">
          <div class="monitor_fire-left">
            <img
              class="top-img"
              src="/images/newscreen/icon/top-fire.png"
            >
          </div>
          <div class="monitor_fire-right">
            <div
              class="monitor_fire-right-title"
              style="color: #E1564D;font-size: 16px;"
            >
              火警
            </div>
            <div
              class="monitor_fire-right-warn"
              style="color: #E1564D;font-size: 24px;"
            >
              {{ tjxxInfo.jthj === null?'0': tjxxInfo.jthj }}
            </div>
          </div>
        </div>
      </div>
      <div class="monitor_fire-body">
        <div class="hj">
          <div class="monitor_fire-left">
            <img
              class="top-img"
              src="/images/newscreen/icon/top-confirm.png"
            >
          </div>
          <div class="monitor_fire-right">
            <div
              class="monitor_fire-right-title"
              style="color: #F1DD55;font-size: 16px;"
            >
              待确认
            </div>
            <div
              class="monitor_fire-right-num"
              style="color: #F1DD55;font-size: 24px;"
            >
              {{ tjxxInfo.dqr === null?'0': tjxxInfo.dqr }}
            </div>
          </div>
        </div>
      </div>
      <div class="monitor_fire-body">
        <div class="hj">
          <div class="monitor_fire-left">
            <img
              class="top-img"
              src="/images/newscreen/icon/top-mistake.png"
            >
          </div>
          <div class="monitor_fire-right">
            <div
              class="monitor_fire-right-title"
              style="color: #BDCAE1;font-size: 16px;"
            >
              误报/其他
            </div>
            <div
              class="monitor_fire-right-num"
              style="color: #BDCAE1;font-size: 24px;"
            >
              {{ tjxxInfo.wb === null?'0': tjxxInfo.wb }}
            </div>
          </div>
        </div>
      </div>
      <div class="monitor_fire-body">
        <div class="hj">
          <div class="monitor_fire-left">
            <img
              class="top-img"
              src="/images/newscreen/icon/top-maintain.png"
            >
          </div>
          <div class="monitor_fire-right">
            <div
              class="monitor_fire-right-title"
              style="color: #BDCAE1;font-size: 16px;"
            >
              维保数量
            </div>
            <div
              class="monitor_fire-right-num"
              style="color: #BDCAE1;font-size: 24px;"
            >
              {{ tjxxInfo.wbcs? tjxxInfo.wbcs: '0' }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="monitor_fire-body"
        @click="showZjxxDialog('1')"
      >
        <div class="hj card-clickable">
          <div class="monitor_fire-left">
            <img
              class="top-img"
              src="/images/newscreen/icon/top-online.png"
            >
          </div>
          <div class="monitor_fire-right">
            <div
              class="monitor_fire-right-title"
              style="color: #BDCAE1;font-size: 14px;"
            >
              在线报警主机
            </div>
            <div
              class="monitor_fire-right-num"
              style="color: #BDCAE1;font-size: 24px;"
            >
              {{ tjxxInfo.zxbjzj? tjxxInfo.zxbjzj: '0' }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="monitor_fire-body"
        @click="showZjxxDialog('0')"
      >
        <div class="hj card-clickable">
          <div class="monitor_fire-left">
            <img
              class="top-img"
              src="/images/newscreen/icon/top-offline.png"
            >
          </div>
          <div class="monitor_fire-right">
            <div
              class="monitor_fire-right-title"
              style="color: #BDCAE1;font-size: 14px;"
            >
              离线报警主机
            </div>
            <div
              class="monitor_fire-right-num"
              style="color: #BDCAE1;font-size: 24px;"
            >
              {{ tjxxInfo.lxbjzj? tjxxInfo.lxbjzj: '0' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="monitor_fire-row monitor_fire-row--second">
      <div
        class="monitor_fire-body"
        @click="showWxygDialog('1')"
      >
        <div class="hj card-clickable">
          <div class="monitor_fire-left">
            <img
              class="top-img"
              src="/images/newscreen/icon/top-wirelessSmokerDetector-online.svg"
            >
          </div>
          <div class="monitor_fire-right">
            <div
              class="monitor_fire-right-title"
              style="color: #BDCAE1;font-size: 14px;"
            >
              在线无线烟感
            </div>
            <div
              class="monitor_fire-right-num"
              style="color: #BDCAE1;font-size: 24px;"
            >
              {{ tjxxInfo.zxwxyg? tjxxInfo.zxwxyg: '0' }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="monitor_fire-body"
        @click="showWxygDialog('0')"
      >
        <div class="hj card-clickable">
          <div class="monitor_fire-left">
            <img
              class="top-img"
              src="/images/newscreen/icon/top-wirelessSmokerDetector-offline.svg"
            >
          </div>
          <div class="monitor_fire-right">
            <div
              class="monitor_fire-right-title"
              style="color: #BDCAE1;font-size: 14px;"
            >
              离线无线烟感
            </div>
            <div
              class="monitor_fire-right-num"
              style="color: #BDCAE1;font-size: 24px;"
            >
              {{ tjxxInfo.lxwxyg? tjxxInfo.lxwxyg: '0' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { monitorService } from '../monitor.service';
import EventBus from '@/event-bus';

export default {
  name: 'DetailTopBoxT',
  props: {
    // 联网单位
    code: {
      type: String,
      default: ''
    },
    // 建筑物id
    jzwId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      clock: null,
      // 火警信息
      tjxxInfo: {
        wbcs: '0',
        wb: '0',
        dqr: '0',
        zshj: '0',
        jthj: '0',
        zxbjzj: '0', // 在线报警主机
        lxbjzj: '0', // 离线报警主机
        zxwxyg: '0', // 在线无线烟感
        lxwxyg: '0'  // 离线无线烟感
      }
    };
  },
  methods: {
    queryTjxxs () {
      const param = {};
      if (this.jzwId) {
        param.jzwId = this.jzwId;
      }
      monitorService.queryTjxxsByJzwId(param)
        .then(rsp => {
          this.tjxxInfo = rsp.data;
        });
    },
    showZjxxDialog (lx) {
      // 确保事件总线已经正确导入
      if (!EventBus) {
        return;
      }

      // 当lx为'0'且无离线主机时直接返回
      if (lx === '0' && (!this.tjxxInfo.lxbjzj || this.tjxxInfo.lxbjzj <= 0)) {
        console.log('没有离线主机，不显示弹窗');
        return;
      }

      // 当lx为'1'且无在线主机时直接返回
      if (lx === '1' && (!this.tjxxInfo.zxbjzj || this.tjxxInfo.zxbjzj <= 0)) {
        console.log('没有在线主机，不显示弹窗');
        return;
      }
      const params = {
        lx: String(lx),
        jzwId: this.jzwId
      };
      // 触发事件，传递参数
      EventBus.$emit('showZjxxDialog', params);
    },
    showWxygDialog (lx) {
      // 确保事件总线已经正确导入
      if (!EventBus) {
        return;
      }

      // 当lx为'0'且无离线无线烟感时直接返回
      if (lx === '0' && (!this.tjxxInfo.lxwxyg || this.tjxxInfo.lxwxyg <= 0)) {
        console.log('没有离线无线烟感，不显示弹窗');
        return;
      }

      // 当lx为'1'且无在线无线烟感时直接返回
      if (lx === '1' && (!this.tjxxInfo.zxwxyg || this.tjxxInfo.zxwxyg <= 0)) {
        console.log('没有在线无线烟感，不显示弹窗');
        return;
      }
      const params = {
        lx: String(lx),
        jzwId: this.jzwId
      };
      // 触发事件，传递参数
      EventBus.$emit('showWxygDialog', params);
    }
  },
  watch: {
    jzwId (newVal, oldVal) {
      this.jzwId = newVal;
      this.queryTjxxs();
    }
  },
  created () {
    const _this = this;
    this.queryTjxxs();
    this.clock = setInterval(function () {
      _this.queryTjxxs();
    }, 10 * 1000);
  },
  destroyed () {
    clearInterval(this.clock);
  }
};
</script>

  <style scoped lang="scss">
  .monitor_fire {
    //height: 240px; /* 增加高度以容纳两行 */
    padding: 23px 15px 0px 15px;
    display: flex;
    flex-direction: column; /* 改为纵向排列 */
    justify-content: flex-start;
    gap: 20px; /* 两行之间的间距 */
    width: 100%;
  }

  .monitor_fire-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    width: 100%;
    overflow-x: auto;
  }

  .monitor_fire-row--second {
    justify-content: flex-start;
    gap: 9px; /* 两行之间的间距 */
  }

  .monitor_fire-body{
    display: flex;
    flex: 0 0 auto;
    &:last-child {
      margin-right: 0;
    }
  }
  .hj {
    display: flex;
    z-index: -1;
    width: 150px; /* 稍微减小宽度确保有足够空间显示所有卡片 */
    height: 65px;
    background-image: url('/images/newscreen/bg/Title.png');
    background-size: 100% 100%;
  }

  .monitor_fire-left{
    padding: 14px 10px 14px 12px;
    display: flex;
    align-items: center;
  }

  .top-img {
    width: 39px;
    height: 39px;
  }

  .monitor_fire-right {
    margin: 12px 0 0 0px;

    &-title{
      font-family: MicrosoftYaHei;
      color: #FFFFFF;
      font-weight: 400;
      font-size: 14px;
      font-stretch: normal;
      font-weight: normal;
      white-space: nowrap; /* 防止文字换行 */
    //   color: #d6dee7;
    }

    &-num {
      margin: 8px 0 0 0;
      font-family: PangMenZhengDao;
      font-size: 20px;
      font-stretch: normal;
      font-weight: normal;
      letter-spacing: 0;
      color: #278dff;
    }

    &-warn {
      margin: 8px 0 0 0;
      font-family: PangMenZhengDao;
      font-size: 20px;
      font-stretch: normal;
      font-weight: normal;
      letter-spacing: 0;
      color: #e4584e;
    }
  }

  .card-clickable {
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.03);
      box-shadow: 0 0 10px rgba(0, 204, 255, 0.5);

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 2px solid #00ccff;
        border-radius: 5px;
        pointer-events: none;
      }
    }

    &:active {
      transform: scale(0.98);
    }
  }

  /* 为了适应不同屏幕大小的响应式处理 */
  @media screen and (max-width: 1400px) {
    .hj {
      width: 140px;
    }

    .monitor_fire-right-title {
      font-size: 12px !important;
    }

    .monitor_fire-right-num,
    .monitor_fire-right-warn {
      font-size: 18px !important;
    }
  }
  </style>
